import React from 'react';
import { useTranslation } from 'react-i18next';
const ReturnCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useTranslation();
    const returnType = (value) => {
        switch (value === null || value === void 0 ? void 0 : value.toLowerCase()) {
            // case 'sent':
            // case 'confirmed':
            // case 'new':
            // case 'requested':
            //   return {
            //     title: <h4 className="title">{t('highlights.return.guidelines')}</h4>,
            //     text: <p dangerouslySetInnerHTML={{ __html: t('account.highlights.returnsguidelines', { faq: props.faq, sClient: props.cService }) }}></p>,
            //   };
            case 'cancelled':
            case 'canceled':
                return {
                    title: React.createElement("h4", { className: "title" }, t('highlights.return.cancelledtitle')),
                    text: React.createElement("p", { dangerouslySetInnerHTML: { __html: t('highlights.return.cancelledtext', { cService: props.cService }) } }),
                };
            case 'returned':
            case 'partially returned':
            case 'partially approved':
                return {
                    title: React.createElement("h4", { className: "title" }, t('highlights.return.returnedtitle')),
                    text: React.createElement("p", { dangerouslySetInnerHTML: { __html: t('highlights.return.returnedtext', { cService: props.cService }) } }),
                };
            default:
                return {
                    title: React.createElement("h4", { className: "title" }, t('highlights.return.guidelines')),
                    text: React.createElement("p", { dangerouslySetInnerHTML: { __html: t('account.highlights.returnsguidelines', { faq: props.faq, cService: props.cService }) } }),
                };
        }
    };
    const returnTypeInfo = returnType(props.orderReturn.status.value);
    return (React.createElement("div", { className: "appointment-card order-returns-card" },
        React.createElement("div", { className: "wrapper__left appointment-card__main" },
            React.createElement("h4", { className: "appointment-number" },
                t('return.label.returnN'),
                "\u00A0", (_a = props.orderReturn) === null || _a === void 0 ? void 0 :
                _a.returnCaseNumber),
            React.createElement("h4", { className: "return-type-title" }, (_b = props === null || props === void 0 ? void 0 : props.orderReturn) === null || _b === void 0 ? void 0 : _b.status.displayValue),
            ((_c = props === null || props === void 0 ? void 0 : props.orderReturn) === null || _c === void 0 ? void 0 : _c.orderNumber) ? (React.createElement("div", { className: "left__details" },
                React.createElement("div", { className: "left__details__flex" },
                    React.createElement("h6", null,
                        t('order.ordernumber'),
                        ": "),
                    React.createElement("p", { className: "uppercase" },
                        React.createElement("a", { href: `${window.location.href.split('#feed')[0]}order/?orderId=${(_d = props.orderReturn) === null || _d === void 0 ? void 0 : _d.orderNumber}` }, (_e = props === null || props === void 0 ? void 0 : props.orderReturn) === null || _e === void 0 ? void 0 : _e.orderNumber))))) : null,
            (props === null || props === void 0 ? void 0 : props.orderReturn.creationDate) ? (React.createElement("div", { className: "left__details" },
                React.createElement("div", { className: "left__details__flex" },
                    React.createElement("h6", null,
                        t('label.date'),
                        ": "),
                    React.createElement("p", { className: "uppercase" }, (_f = props === null || props === void 0 ? void 0 : props.orderReturn) === null || _f === void 0 ? void 0 : _f.creationDate)))) : null,
            ((_g = props === null || props === void 0 ? void 0 : props.orderReturn) === null || _g === void 0 ? void 0 : _g.totals) ? (React.createElement("div", { className: "left__details" },
                React.createElement("div", { className: "left__details__flex" },
                    React.createElement("h6", null,
                        t('order.total'),
                        ": "),
                    React.createElement("p", { className: "uppercase" }, props === null || props === void 0 ? void 0 : props.orderReturn.totals.grossTotal)))) : null,
            React.createElement("div", { className: "col-12 col-sm-6 col-xl-4 btn-group" },
                React.createElement("a", { href: `${window.location.href.split('#feed')[0]}return/?orderId=${props.orderReturn.returnCaseNumber}`, className: "button button--tertiary" },
                    t('highlights.return.btn.showdetails'),
                    React.createElement("span", { className: "icon--chevron-small-right" })))),
        React.createElement("div", { className: "wrapper__right order-returns-card__secondary" },
            returnTypeInfo.title,
            returnTypeInfo.text)));
};
export default ReturnCard;
